import { Dialog, Slide } from "@mui/material";
import React, { useEffect, useState } from "react";
import { KeyboardBackspace } from "@mui/icons-material";
import { TransitionProps } from '@mui/material/transitions';
import { Box, Button, useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ItemDetailPost from "./itemDetailPostComment";

import { IUserComment } from "../../commons/interfaces";
import { ICommunityPostDetail } from "../../containers/channel/useChannel";



const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const PopupItemDetailPostComment = (props: {
    openPopup: boolean;
    dataDetailPost?: ICommunityPostDetail;

    onClose: (data: ICommunityPostDetail) => void;
    onShowUserProfile?: (data: IUserComment) => void;
    onEditPost?: (data: ICommunityPostDetail) => void;

}) => {

    const Strings = useStrings();
    const { onHideLoading, onShowLoading } = useCommonComponentContext();

    const [isDetail, setIsDetail] = useState(false);
    const [dataDetailPost, setDataDetailPost] = useState<ICommunityPostDetail>({} as ICommunityPostDetail);

    useEffect(() => {
        onShowLoading();

        if (Helpers.isNullOrEmpty(props.dataDetailPost?.id)) {
            setDataDetailPost({} as ICommunityPostDetail);
            setIsDetail(false);
        } else {
            setDataDetailPost(props.dataDetailPost);
            setIsDetail(true);
        }

        onHideLoading();
    }, [props.dataDetailPost?.id]);

    return (
        <>
            <Dialog
                fullScreen
                open={props.openPopup}
                TransitionComponent={Transition}
                onClose={() => { props.onClose(dataDetailPost) }}
            >
                <Box sx={{ backgroundColor: "#0000000f" }}>
                    <Box sx={{ display: "flex", justifyContent: "start" }}>
                        <Button variant="text" color="dark" onClick={() => { props.onClose(dataDetailPost) }}>
                            <KeyboardBackspace /> &ensp;
                            {Strings.Common.GO_BACK}
                        </Button>
                    </Box>

                    <>
                        <ItemDetailPost
                            isDetail={isDetail}
                            dataDetail={dataDetailPost}

                            onEditPost={props.onEditPost}
                            onShowUserProfile={props.onShowUserProfile}
                            onCallBack={(data, isDelete) => {
                                if (isDelete) {
                                } else {
                                    setDataDetailPost(data);
                                }
                            }}
                        />
                    </>
                </Box>
            </Dialog>
        </>
    );
};

export default PopupItemDetailPostComment;
